import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import UploadOneFileForm from '../Forms/UploadOneFileForm';

const UploadOneFileModal = ({
	folderId,
	fileTypeId,
	handleUploadLocalFile,
	handleDeleteLocalFile,
	isOpen,
	isEdit,
	handleToggleModal,
	handleNewDocumentId,
	activeTab,
	toggleTab
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='md'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				Subir Archivo
			</ModalHeader>
			
			<UploadOneFileForm
				folderId={folderId}
				fileTypeId={fileTypeId}
				handleUploadLocalFile={handleUploadLocalFile}
				isOpen={isOpen}
				handleToggleModal={handleToggleModal}
				handleNewDocumentId={handleNewDocumentId}
				activeTab={'1'}
				toggleTab={() => { }}
			/>
		</Modal>
	);
};

export default UploadOneFileModal;
